/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
    this.cartElement = document.querySelector("ajax-cart");

    this.qtyInputs = this.querySelectorAll('[data-qty-input][name="quantity"]');
    this.qtyInputs.forEach((qtyInput) =>
      qtyInput.addEventListener("keyup", this.manageQtyInput.bind(this))
    );

    this.qtyBtns = this.querySelectorAll("[data-qty-btn]");
    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
    );
  }

  manageQtyInput(event) {
    let input = event.currentTarget;
    if (input.value < 0) input.value = Math.abs(input.value);
    if (input.value.length > 2) input.value = input.value.slice(0, 2);
    //event.preventDefault();
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector("[data-qty-input]");
    const pdpContainer = this.closest(".product-details-wrapper");

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    // Card body of either Mega menu or PLP layout
    const cardBody = submitButton.closest('.mega_menu_container') || submitButton.closest('.card-product');
    if (cardBody) {
      cardBody.classList.add('loading');
    }

    addItems.push(JSON.parse(serializeForm(this.form)));
    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll(
        "[data-addon-selection]:checked"
      );
      addOnItemsEle.forEach((addOn) => {
        if (!addOn.disabled) {
          let addOnParent = addOn.closest("addons-form");
          let addOnJSON = {
            id: addOnParent.querySelector(".variant--id").value,
            quantity: addOnParent.querySelector(".product-quantity").value,
          };
          addItems.push(addOnJSON);
        }
      });
    }

    let is_sale_auto_disocunt = false;
    if (window.theme.vip && window.theme.vip.auto_discount_code != '' && window.theme.vip.auto_discount_percent > 0) {
      if (cardBody) {
        if (cardBody.dataset.autoDiscountPercent > 0) {
          is_sale_auto_disocunt = true;
        }
      } else {
        is_sale_auto_disocunt = true;
      }
    }

    if (is_sale_auto_disocunt) {
      let propertyKey = 'sale_auto_discount_' + Math.round(window.theme.vip.auto_discount_percent);
      
      addItems[0].properties = {};
      addItems[0].properties[propertyKey] = true;
    }
    
    
    const body = JSON.stringify({
      items: addItems,
    });

    // Variant ID of the product added
    let variant_id = this.form.id.value;

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if (is_sale_auto_disocunt) {
          window.location.href = `/checkout/?discount=${window.theme.vip.auto_discount_code}`;
          return;
        }
        
        if (document.querySelector("#PopupModal-quickshop")) {
          document
            .querySelector("#PopupModal-quickshop .close-quickshop")
            .dispatchEvent(new Event("click"));
        }

        // Remove products if you added an "Upgrade"-type upsell product like LED Essential Bundle
        const upsell_block = this.closest('.cart-upsell');
        if (upsell_block) {
          let pdpUpsellVariantId = upsell_block.dataset.upsellVariantId;

          let productsToRemove = upsell_block
              .getAttribute("data-products-remove")
              .split(",");
      
          // remove the last element of the array if it's empty
          if (productsToRemove[productsToRemove.length - 1] === "") {
            productsToRemove.pop();
          }

          if (productsToRemove.length > 0) {
            productsToRemove = productsToRemove.filter(variantId => {
              return window.globalVariables.cart.items.filter(e => e.id == variantId).length > 0
            });
          }

          if (productsToRemove.length > 0) {
            this.cartElement.dispatchEvent(new CustomEvent('upsell-product-added', {
              detail: {
                productsToRemove: productsToRemove,
                pdpUpsellVariantId: pdpUpsellVariantId
              },
              bubbles: true
            }));
          } else {
            const pdpUpsellContainer = document.querySelector('.section-upgrade-bundle .cart-upsell');
            if (pdpUpsellContainer && pdpUpsellVariantId == pdpUpsellContainer.dataset.upsellVariantId) {
              pdpUpsellContainer.closest('.section-upgrade-bundle').classList.add('hidden');
            }

            this.cartElement.getCartData("open_drawer");
          }
        } else {
          // Product without upsell properties
          let pdpUpsellContainer = document.querySelector('.section-upgrade-bundle .cart-upsell');
          if (pdpUpsellContainer && pdpUpsellContainer.dataset.productsRemove.split(',').includes(variant_id)) {
            // Change the CTA to "Upgrade to bundle"
            pdpUpsellContainer.querySelector('.addtocartbtn .add-text').innerText = pdpUpsellContainer.dataset.ctaLabelUpgrade;
          }

          this.cartElement.getCartData("open_drawer");
        }

        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (is_sale_auto_disocunt) {
          // KEEP LOADING
        } else {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
  
          if (cardBody) {
            cardBody.classList.remove('loading');
          }
        }
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || "increase";
    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == "decrease" && currentQty <= 1) {
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }
    $qtyInput.value = finalQty;
  }
}
customElements.define("product-form", ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest("form") || this.closest(".form-element");
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector("[data-variantJSON]");
    this.variantPicker = this.dataset.type;

    if (this.formType == "product-page") this.onVariantChange("load");
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    if (this.formType == "product-page")
      window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton("disable");
      // Variant name update
      let options = this.form.querySelectorAll("[data-optionindex]");
      options.forEach((option) => {
        let lableID = "option" + option.dataset.optionindex;
        const selectedValue = option.querySelector(
          'input[type="radio"]:checked'
        );
        const lable = option.querySelector(".selected-option");
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == "grid") {
        const productGrid = this.closest("[data-product-grid]");
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest("[data-product-container]");
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton("enable");

      let skio = document.querySelector("skio-plan-picker");
      if (skio) skio.selectedVariant = this.currentVariant;
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = "?variant=" + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll(".product-link");
    formLinks.forEach((link) => {
      let href = link.href.split("?")[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll(".variant_selector").forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(
      this.querySelectorAll("fieldset:not(.addon-fieldset)")
    );
    return fieldsets.map((fieldset) => {
      return Array.from(
        fieldset.querySelectorAll("input:not(.addon-swatch)")
      ).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options =
      this.variantPicker == "variant-select"
        ? this._getOptionsFromSelect()
        : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID, preserving all other params
    if (this.formType == "product-page") {
      const currentUrl = new URL(window.location.href);
      const params = new URLSearchParams(currentUrl.search);
      params.set("variant", currentVariant.id);
      const newUrl = `${this.dataset.url}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  calculatePriceWithTaxes(price, country) {
    const taxData = window.taxData;

    if (!taxData[country]) return price;
    return price * (1 + taxData[country]);
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant
   * @param {element} container
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    const customerCountry = window.customerCountry;

    let priceRaw = currentVariant.price;
    let comparePriceRaw = currentVariant.compare_at_price;

    if (customerCountry == 'US') {
      if (window.theme.vip && window.theme.vip.auto_discount_code != '' && window.theme.vip.auto_discount_percent > 0) {
        priceRaw = currentVariant.price * (100 - window.theme.vip.auto_discount_percent) / 100;
        comparePriceRaw = currentVariant.price * window.theme.vip.price_mock_ratio;
      }
    }

    // Price Update
    let price = Shopify.formatMoney(
      this.calculatePriceWithTaxes(priceRaw, customerCountry),
      window.globalVariables.money_format
    );
    
    let compare_price = Shopify.formatMoney(
      this.calculatePriceWithTaxes(
        comparePriceRaw,
        customerCountry
      ),
      window.globalVariables.money_format
    );
    let priceElement = container.querySelector("[data-currentPrice]");
    let comparePriceElement = container.querySelector("[data-comparePrice]");

    // console.log("price", price);
    // console.log("compare_price", compare_price);
    // console.log("priceElement", priceElement);
    // console.log("comparePriceElement", comparePriceElement);

    // Afterpay
    //let squarePlacement = document.querySelector('square-placement');
    //squarePlacement && squarePlacement.dataset.amount = priceRaw/100;

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (comparePriceRaw <= 0) {
        comparePriceElement.style.display = "none";
      } else {
        comparePriceElement.style.display = "block";
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == "grid") {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector("[data-feauredImage]");
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(
        `.product--media[data-mediaID="${imageID}"]`
      );
      if (this.formType == "quickshop") {
        imageSlide = document.querySelector(
          `.quickshop-slider .product--media[data-mediaID="${imageID}"]`
        );
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
        imageSlide
      );
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll("[data-optionindex]");
    options.forEach((option) => {
      let lableID = "option" + option.dataset.optionindex;
      const lable = option.querySelector(".selected-option");
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    // console.log("we are here first");

    if (status == "disable") {
      this.addBtn.setAttribute("disabled", true);
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute("disabled", true);
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute("disabled");
      if (this.form.classList.contains("cart-upsell-form")) {
        // console.log("we are here");
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.upsellAddText;
      } else {
        const addBtnSpan = this.addBtn.querySelector(".add-text");
        if (typeof addBtnSpan.dataset.addtocartLabel !== 'undefined') {
          addBtnSpan.textContent = addBtnSpan.dataset.addtocartLabel;
        } else {
          addBtnSpan.textContent = window.variantStrings.addToCart;
        }
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest("form") || this.querySelector(".form-element");
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector(".color-swatch");
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll(".swatch");
      colorSwatches.forEach((swatch) => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset
          .handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch
          .querySelector(".swatch-label")
          .setAttribute("style", swatchStyle);
      });
    }
  }
}
customElements.define("variant-radios", VariantRadios);
